export const OTLP_SEVERITY = {
    silly: [1, 'TRACE'],
    debug: [5, 'DEBUG'],
    verbose: [5, 'DEBUG'],
    http: [9, 'INFO'],
    info: [9, 'INFO'],
    warn: [13, 'WARN'],
    error: [17, 'ERROR'],
};
export const OTLP_MAX_ATTRIBUTES = 30;
export const OTLP_MAX_ATTRIBUTE_CHARS = 4000;
export const OTLP_MAX_BODY_CHARS = 8000;
export function otlpStringify(value, maxChars) {
    let text;
    if (typeof value === 'string') {
        text = value;
    }
    else {
        try {
            text = JSON.stringify(value) ?? String(value);
        }
        catch {
            text = String(value);
        }
    }
    return text.length > maxChars ? `${text.slice(0, maxChars)}…` : text;
}
export function otlpAttributes(attributes) {
    return Object.entries(attributes)
        .filter(([, value]) => value !== undefined && value !== null)
        .slice(0, OTLP_MAX_ATTRIBUTES)
        .map(([key, value]) => ({
        key,
        value: { stringValue: otlpStringify(value, OTLP_MAX_ATTRIBUTE_CHARS) },
    }));
}
export function otlpLogRecord(level, message, attributes, timeMs) {
    const [severityNumber, severityText] = OTLP_SEVERITY[level] ?? OTLP_SEVERITY.info;
    return {
        timeUnixNano: `${Math.round(timeMs)}000000`,
        severityNumber,
        severityText,
        body: { stringValue: otlpStringify(message, OTLP_MAX_BODY_CHARS) },
        attributes: otlpAttributes(attributes),
    };
}
export function otlpLogsPayload(logRecords, resource, scopeName) {
    return {
        resourceLogs: [
            {
                resource: { attributes: otlpAttributes(resource) },
                scopeLogs: [{ scope: { name: scopeName }, logRecords }],
            },
        ],
    };
}
//# sourceMappingURL=posthog-otlp.js.map